// Tested
export const querySelectorOrThrow = <T extends Element>(context: ParentNode, selector: string) => {
	const el = context.querySelector(selector);
	if (el === null) {
		throw new Error(`Cannot match element using selector '${selector}'`);
	}
	return el as T;
};
